<template>
    <div class="modal-window alert ab028">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.dialog.notice","알림") }}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="info-txt small"  v-if="deleteMessageYn" v-html="$i18nUtil.trans('message.DeleteFolderAlert.001','삭제 시 해당 폴더 하위의 보드가 모두 삭제됩니다.<br>폴더를 삭제하시겠습니까?')"></div>
            <div class="info-txt small"  v-if="failYn">{{ $i18nUtil.trans("message.DeleteFolderAlert.002","등록된 폴더가 1개 이하인 경우 삭제할 수 없습니다.") }}</div>
        </div>

        <footer class="modal-footer"  >
            <button type="button" class="btn_ty1" @click="callModalsContainer"  v-if="deleteMessageYn">{{ $i18nUtil.trans("button.delete","삭제") }}</button>
            <button type="button" class="btn_ty1" @click="$emit('close')"  v-if="failYn">{{ $i18nUtil.trans("button.confirm","확인") }}</button>
        </footer>
    </div>
</template>
<script>

export default {
    props:{
        modalInfo: {
            type: Object,
            required: true,
        },
    },
    components: {
    },
    data() {
        return { 
            deleteMessageYn: true,
            failYn : false,
        };
    },
    methods: {  
        callModalsContainer(){
            if(this.modalInfo.myFolderListLength <= 1){
                this.failYn =true;
                this.deleteMessageYn = false;
            }else{
                let param = {
                    selectedFolder : this.modalInfo.selectedFolder, 
                    parentCategoryMid : this.modalInfo.parentCategoryMid
                }
                this.$emit("deleteFolder",param);
                this.$emit("close");
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/modal/DeleteFolderAlert.vue